import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import styles from "./SettingsInput.module.scss";
import { combineClasses } from "@/lib/utils";

export interface SettingsInputProps extends InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string;
}

const SettingsInput = forwardRef<HTMLInputElement, SettingsInputProps>(
  ({ className = "", wrapperClassName = "", id, ...props }, ref) => {
    return (
      <div className={combineClasses(styles.inputWrapper, wrapperClassName)}>
        <input
          ref={ref}
          id={id}
          className={combineClasses(styles.textInput, className)}
          {...props}
        />
      </div>
    );
  }
);

SettingsInput.displayName = "SettingsInput";

export default SettingsInput;
